import { COURSE_FETCH_STARTED } from '../../types';
export const startCourseFetch = () => ({
  type: COURSE_FETCH_STARTED
});